module.exports = __webpack_public_path__ + "static/media/auth-login-illustration-dark.51c05fd3.png";